var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHuntingIconYs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 146,
    height: 146,
    viewBox: "0 0 146 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.0155 53.1936L76.7589 55.3216C79.5049 55.4549 83.9823 55.2764 86.7093 54.9258L102.605 53.5175C104.324 53.2967 104.979 51.791 104.851 49.9157L103.349 45.8729C102.919 44.6071 104.17 43.4197 105.411 43.9157L116.452 48.1899C118.288 48.923 120.037 49.8515 121.673 50.9606L130.009 56.2148C131.829 57.4495 131.852 61.3364 130.117 62.6875C127.288 64.891 124.257 65.5831 120.679 65.8209L113.777 66.2788C112.369 66.3726 111.021 66.8891 109.911 67.7604L86.7855 86.9013L94.8365 122.621H87.4261L76.0724 85.7449L71.6479 85.7957C63.6223 85.8889 55.6749 84.2005 48.381 80.8505L46.3694 87.4524C45.6089 89.95 44.5061 92.3312 43.0943 94.5283L38.8454 100.906C38.3276 101.712 38.0362 103.171 38.5216 104.548L45.0366 122.621H37.119L31.2206 106.592C30.443 104.201 30.1368 101.683 30.3196 99.1772L30.6434 92.7045L24.5051 81.8157C21.6914 74.9867 22.234 67.903 26.0065 61.177C30.9694 52.3308 43.0082 52.9545 48.0155 53.1936Z",
    stroke: "currentColor",
    strokeWidth: 10.95,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.592 87.6001L16.3545 101.578C16.0059 102.26 15.8239 103.016 15.8239 103.783L14.5977 125.77H24.6054L25.4718 108.251C25.579 106.815 25.9537 105.412 26.576 104.115L30.4332 95.6913M65.6976 89.5418L62.2263 125.77H72.2251L77.0835 92.6173",
    stroke: "currentColor",
    strokeWidth: 5.475,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8984 9.56511L104.715 25.8563L117.716 30.7655L120.448 47.4503M105.741 7.30029L98.5484 14.6003M114.965 18.6279L109.594 26.995",
    stroke: "currentColor",
    strokeWidth: 5.475,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHuntingIconYs);
export default __webpack_public_path__ + "static/media/hunting_icon_ys.246b701a8a5c9b590a0b896db2de8dbd.svg";
export { ForwardRef as ReactComponent };